import { IntegrationEnvironment } from "../../ServerEndpoints";
import { SetState, StoreData } from "../types";

export const setEnvironment = (set: SetState<StoreData>) => (environment: IntegrationEnvironment) =>
  set({ environment });
